/* eslint-disable */

import { register } from 'register-service-worker'
import router from './router/index'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker-nokumo.js`, {
    ready() {},
    registered(e) {
      // once service router is registered - we want it to check for updates and update on each route change.
      // if update was available, service worker updates and 'updated' method below is triggered.
      // this dispatches 'swUpdated' event which is handled in App.vue - banner is shown letting user know the app
      // needs to be refreshed to load the latest service worker version.
      router.afterEach((to, from) => { 
        e.update();
      });
    },
    cached() {},
    updatefound() {},
    updated(registration: ServiceWorkerRegistration) {
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }))
    },
    offline() {},
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
